var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconUiPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 25 25",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.53 23.92v-9.41h-9.4c-.6 0-1.13-.54-1.13-1.14v-1.68c0-.6.54-1.14 1.14-1.14h9.39V1.08c0-.6.53-1.08 1.13-1.08h1.68c.6 0 1.13.48 1.13 1.08v9.47h9.45c.6 0 1.08.54 1.08 1.14v1.68c0 .6-.48 1.14-1.08 1.14h-9.45v9.41c0 .6-.53 1.08-1.13 1.08h-1.68c-.6 0-1.13-.48-1.13-1.08z",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "media/images/styleguide/icons/icon-ui--plus-599663992de4ab6f38479237cb69b9bf.svg";
export { SvgIconUiPlus as Component };